"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FlatFilter_1 = require("../../../helpers/Functions/FlatFilter");
var Join_1 = require("../../../helpers/Functions/Join");
var Alert_1 = require("../Alert");
var sortOrder = {
    error: 0,
    warning: 1,
    info: 2,
    success: 3,
};
var comparator = function (_a, _b) {
    var _c = _a.type, lhs = _c === void 0 ? Alert_1.defaultType : _c;
    var _d = _b.type, rhs = _d === void 0 ? Alert_1.defaultType : _d;
    return sortOrder[lhs] - sortOrder[rhs];
};
/** Render a list of alerts. This will also sort them in the proper order automatically and atomically. */
var AlertList = function (_a) {
    var className = _a.className, alerts = _a.alerts, style = _a.style, _b = _a.addBottomMargin, addBottomMargin = _b === void 0 ? true : _b, testId = _a.testId, listProps = __rest(_a, ["className", "alerts", "style", "addBottomMargin", "testId"]);
    var filtered = FlatFilter_1.flatfilter(alerts);
    return filtered.length > 0 ? (React.createElement("ul", { "data-testid": testId }, filtered
        .sort(comparator)
        .map(function (_a, index) {
        var nClassName = _a.className, nStyle = _a.style, alertProps = __rest(_a, ["className", "style"]);
        return (React.createElement("li", { className: "mar-b-md" },
            React.createElement(Alert_1.default, __assign({ className: Join_1.join(className, nClassName), key: index, renderInList: true, style: __assign(__assign({}, style), nStyle) }, alertProps, listProps))));
    }))) : null;
};
exports.default = AlertList;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/AlertList/AlertList.js
// module id = 667
// module chunks = 8